<script setup lang="ts">import { ref as _ref } from 'vue';

import { onMounted } from "vue";
import { v4 as uuid } from "uuid";

import RsViewerAnnotationHighlight from "./ViewerAnnotationHighlight.vue";

import { markDefaults } from "@/services/AnnotationService";

import type { ParsedMark } from "@/models/Mark";
import type { PageData } from "@/models/PageData";
import type { TextLine } from "@/models/Viewer";
import type { HighlightAnnotation } from "@/models/Annotation";

withDefaults(defineProps<{
  type: "HighlightAnnotation" | "TextSelectionRedaction" | "SelectText";
  pageDimensions: PageData;
  pageScale: number;
  pageNumber: number;
  fileReference: string;
  textLines: TextLine[];
  mousePosition: { x: number; y: number } | null;
}>(), {  })
let annotation = _ref<ParsedMark<HighlightAnnotation> | null>(null);

onMounted(() => {
  const markData = {
    data: { status: "user" },
    ...markDefaults[__props.type],
    pageNumber: __props.pageNumber,
    uid: uuid(),
    conversation: { comments: [], data: {} },
    creationDateTime: new Date().toISOString(),
    modificationDateTime: new Date().toISOString(),
    type: __props.type,
    lineGroups: [
      {
        pageData: __props.pageDimensions,
        lines: [],
      },
    ],
  } as unknown as HighlightAnnotation;

  annotation.value = {
    fileReference: __props.fileReference,
    markId: markData.uid,
    source: "user",
    supportingFileEntryFileReference: "",
    metadata: undefined,
    evidenceThemes: undefined,
    markData: JSON.stringify(markData),
    parsedMarkData: markData,
  };
});
</script>
<template>
  <RsViewerAnnotationHighlight
    v-if="annotation"
    :page-scale="pageScale"
    :text-lines="textLines"
    :page-number="pageNumber"
    :mouse-position="mousePosition"
    :page-dimensions="pageDimensions"
    :annotation="annotation"
    :is-select="type === 'SelectText'"
    :is-create="/HighlightAnnotation|TextSelectionRedaction/.test(type)"
  />
</template>
